import { render, staticRenderFns } from "./BoardEncryptionForm.vue?vue&type=template&id=1774c6ae&scoped=true&"
import script from "./BoardEncryptionForm.vue?vue&type=script&lang=js&"
export * from "./BoardEncryptionForm.vue?vue&type=script&lang=js&"
import style0 from "./BoardEncryptionForm.vue?vue&type=style&index=0&id=1774c6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1774c6ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VOverlay,VRow})
